import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21b8e4af"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "frisbuy-customer-review__play-icon"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg width=\"29\" height=\"31\" viewBox=\"0 0 29 31\" fill=\"none\" data-v-21b8e4af><g filter=\"url(#filter0_d_4369_3101)\" data-v-21b8e4af><path d=\"M21.4186 12.7112C23.5271 13.9506 23.5271 17.0494 21.4186 18.2888L10.7442 24.5638C8.63566 25.8032 6 24.2539 6 21.7749L6 9.22509C6 6.74611 8.63566 5.19675 10.7442 6.43624L21.4186 12.7112Z\" fill=\"white\" data-v-21b8e4af></path></g><defs data-v-21b8e4af><filter id=\"filter0_d_4369_3101\" x=\"-3\" y=\"-2\" width=\"35\" height=\"35\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-21b8e4af><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-21b8e4af></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-21b8e4af></feColorMatrix><feOffset data-v-21b8e4af></feOffset><feGaussianBlur stdDeviation=\"3\" data-v-21b8e4af></feGaussianBlur><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0\" data-v-21b8e4af></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_4369_3101\" data-v-21b8e4af></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_4369_3101\" result=\"shape\" data-v-21b8e4af></feBlend></filter></defs></svg>", 1)
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted, nextTick } from "vue";
import { Property } from "csstype";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { imageWithPostId } from "@/widgets/MarketplaceReviews/interfaces";

export type MediaListCustomization = {
  wrap?: Property.FlexWrap;
  gap?: Property.Gap;
  mediaWidth?: Property.Width;
  mediaHeight?: Property.Height;
  mediaAspectRatio?: Property.AspectRatio;
};

const errorImagePlug = "https://www.frisbuy.ru/images/empty_media.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaList',
  props: {
    mediaList: {},
    wrap: { default: "nowrap" },
    gap: { default: "5px" },
    mediaWidth: { default: "80px" },
    mediaHeight: { default: "unset" },
    mediaAspectRatio: { default: "1 / 1" }
  },
  emits: ["selectMedia"],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;

const emit = __emit;

function selectMedia(media: imageWithPostId) {
  emit("selectMedia", media);
}

// Safari fix for video height issue
function fixSafariVideoHeight() {
  if (typeof window !== 'undefined' && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
    nextTick(() => {
      const mediaItems = document.querySelectorAll('.frisbuy-customer-review__media-list-item');
      mediaItems.forEach((item: Element) => {
        const htmlItem = item as HTMLElement;
        // Force reflow by toggling display
        const originalDisplay = htmlItem.style.display;
        htmlItem.style.display = 'none';
        htmlItem.offsetHeight; // Force reflow
        htmlItem.style.display = originalDisplay || 'flex';
      });
    });
  }
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

onMounted(() => {
  fixSafariVideoHeight();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: "frisbuy-customer-review__media-list",
    style: _normalizeStyle({
      flexWrap: props.wrap,
      gap: props.gap,
    })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaList, (media, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: idx,
        class: "frisbuy-customer-review__media-list-item",
        style: _normalizeStyle({
        backgroundImage: `url(${_unref(DomainSubstitute)(
          media.thumbnailUrl
        )}), url(${errorImagePlug})`,
        width: props.mediaWidth,
        height: props.mediaHeight,
        aspectRatio: props.mediaAspectRatio,
      }),
        onClick: () => selectMedia(media)
      }, [
        _createElementVNode("img", {
          class: "frisbuy-customer-review__media-image",
          src: _unref(DomainSubstitute)(media.thumbnailUrl),
          onError: errorImageHandler
        }, null, 40, _hoisted_2),
        (media.videoUrl.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ], 12, _hoisted_1))
    }), 128))
  ], 4))
}
}

})